import { Component, Input, OnInit } from '@angular/core';
import {
  WagtailFullBleedSliderItemInterface,
  WagtailFullBleedSliderRendererInterface,
  WagtailFullBleedSliderSize,
  WagtailPageContentElementInterface,
  WagtailPageContentRendererInterface
} from "@gea-waldviertler-website/gea-models";

@Component({
    selector: 'wagtail-page-element-full-bleed-slider',
    templateUrl: './full-bleed-slider.component.html',
    styleUrls: ['./full-bleed-slider.component.scss'],
    standalone: false
})

export class WagtailFullBleedSliderComponent implements OnInit {
  @Input() definition?: WagtailPageContentElementInterface<WagtailPageContentRendererInterface>

  content?: WagtailFullBleedSliderRendererInterface
  identifier?: string
  slides?: WagtailFullBleedSliderItemInterface[]
  size?: WagtailFullBleedSliderSize
  type: "single" | "multi" = "single"

  ngOnInit(): void {
    if (this.definition) {
      this.content = (this.definition.value as WagtailFullBleedSliderRendererInterface)
      this.identifier = this.definition.id
      this.size = this.content.size
      this.type = this.content.slides.length > 1 ? 'multi' : 'single'
      this.slides = this.content.slides
    }
  }
}

